import { store } from "../../store/store";
import type { RootState } from "../../store/store";

export interface AuthMessage {
	type: "auth";
	user_id?: string;
	session_id?: string;
	campaign_context?: {
		customer_id: string;
		account_name: string;
	};
}

export const buildAuthMessageFromState = (state: RootState): AuthMessage => {
	const message: AuthMessage = { type: "auth" };

	const userId = state.user?.buyer_id;
	if (userId != null) {
		message.user_id = String(userId);
	}

	const sessionId = state.session.sessionId;
	if (sessionId) {
		message.session_id = sessionId;
	}

	const activeAdAccountId = state.session.activeAdAccountId;
	if (activeAdAccountId) {
		message.campaign_context = {
			customer_id: activeAdAccountId.replace(/\D/g, ""),
			account_name: "",
		};
	}

	return message;
};

export const buildAuthMessage = (): AuthMessage =>
	buildAuthMessageFromState(store.getState());
